import React from 'react'
import { JournalDetail } from './JournalDetail'
import { JournalList } from './JournalList'
import { useAppSelector } from '../../../redux/hooks'

export const LearningJournal = (): JSX.Element => {
  const { personId } = useAppSelector((state) => state.user)
  const apprentices = useAppSelector((state) => state.apprentices)
  return apprentices.find((app) => personId === app.person_id) ? (
    <JournalDetail />
  ) : (
    <JournalList />
  )
}